/* ============
 * Order Module State
 * ============
 */

export default {
  all: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  types: [],
  currentOrder: {},
  events: [],
  query: {
    page: 1,
    limit: 50,
    search: '',
    isSet: false,
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/order/state.js